export const userStatus = {
  ACTIVE: "active",
  PENDING: "pending",
  BLOCKED: "blocked",
};
